import React from 'react';
import api from "./../../../services/api";
//import { NavLink } from 'react-router-dom';
import './../../../pages/Representante_Instituição/Tela_RI_Cadastro/styles.css';
import './../../../pages/Representante_Instituição/Tela_RI_Pacientes_Cadastro/styles.css';
import { user_token } from '../../../services/Auth';
import "./style.css";
import Grid from '@material-ui/core/Grid';
import SideNav from './../../../components/SideNav_PS';
//import GetMedicalRecord from './GetMedicalRecord';
//import GetAge from './GetAge';
import GetUser from './GetUser';
import FormPM from './../../../components/Forms_ProfissionalDaSaude/Prontuario_DeMonitoracao';

//import da API
import { professional } from './../../../services/api'
let apiProfessional = new professional();

var token = localStorage.getItem(user_token);

export default class Monitoramento extends React.Component {

  state = {
    exames: [],
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    const { id } = this.props.match.params;
    console.log(id);
    // const request = await api.get(`/exam/${id}`, {headers: {'x-access-token': token}});
    const request = await apiProfessional.getExam(id)
    console.log(request);
    console.log(request.data);
    this.setState({ exames: request.data });

  };

  render() {
    return (
      <>
        <SideNav />
        <div id="top-PS">
          <Grid container spacing={0} direction="row" justify="left" alignItems="center" style={{ marginTop: '-35vh' }}>
            <Grid item xs={2} sm={2} md={1} lg={1} align="center">

            </Grid>
            <Grid item xs={8} sm={8} md={10} lg={10}></Grid>
            <Grid item xs={2} sm={2} md={1} lg={1} align="center">
            </Grid>
          </Grid>
        </div>
        <Grid container spacing={0} direction="row" justify="left" alignItems="center">
          <Grid item xs={12} sm={12} md={10} lg={3} align="center"></Grid>
          <Grid item xs={12} sm={12} md={10} lg={6} align="center">
            <div id="main-RI-Consulta-Pendente">
              <h1 id="title">Prontuário de Monitoração</h1>
              <br></br>
              <div id="lista-style">
                {this.state.exames.map(details => (
                  <>
                    <div id="exam">
                      <h1 id="tittle-forms-cme">Informações da Consulta</h1>
                      <hr id="coloring_line" />
                      <p id="RI-Title-Cadastro-Paciente" >Tipo de consulta: </p><p>{details.appointment_type}</p>
                      <p id="RI-Title-Cadastro-Paciente" >Especialidade: </p><p>{details.medical_appointment_type}</p>
                      <p id="RI-Title-Cadastro-Paciente" >Motivo da consulta: </p><p>{details.appointment_purpose}</p>
                      <p id="RI-Title-Cadastro-Paciente" >Período da consulta: </p><p>{details.appointment_period}</p>
                      <p id="RI-Title-Cadastro-Paciente" >Observações: </p><p>{details.notes}</p>
                      <hr id="coloring_line" />
                      <br></br>

                      <h1 id="tittle-forms-cme">Informações do Paciente</h1>
                      <hr id="coloring_line" />
                      <GetUser user_id={details.user_id} />
                      <hr id="coloring_line" />
                      <br></br>




                      <FormPM exam_id={details._id} />
                    </div>
                    <div>
                    </div>
                  </>
                ))}
              </div>
            </div>
          </Grid>
        </Grid>
      </>
    );
  }
}
